import { webSocketService } from '~/services/WebSocketService'
import { useRealTimePriceStore } from '~/stores/RealTimePriceStore'

export default defineNuxtPlugin((nuxtApp) => {
  const priceStore = useRealTimePriceStore()

  // Initialize WebSocket service and connect to price store
  const initializeWebSocketService = () => {
    if (!webSocketService) {
      console.error('WebSocket service not available')
      return
    }

    // Global handler for price messages
    const handlePriceMessage = (message: any) => {
      if (message && message.data) {
        try {
          const {
            useRealTimePriceStore
          } = require('~/stores/RealTimePriceStore')
          const priceStore = useRealTimePriceStore()
          priceStore.updatePrice(message.data)
        } catch (_error) {
          // Silent error handling for production
        }
      }
    }

    // Set up status change handlers
    webSocketService.onStatusChange((status, _exchange, _symbol) => {
      // WebSocket status change tracked

      // Update connection status in price store
      if (status.status === 'connected') {
        priceStore.setConnectionStatus('connected')
      } else if (
        status.status === 'error' ||
        status.status === 'disconnected'
      ) {
        priceStore.setConnectionStatus('disconnected')
      }
    })

    // Track previous connections to avoid unnecessary setup
    let previousConnections = new Set<string>()

    // Set up message handlers for all active connections
    const setupHandlersForActiveConnections = () => {
      if (!webSocketService) return

      const activeConnections = webSocketService.getActiveConnections()

      // Only log and setup if connections have changed
      if (activeConnections.length !== previousConnections.size ||
          !activeConnections.every(conn => previousConnections.has(conn))) {
        // Setting up handlers for active connections

        activeConnections.forEach((connectionKey) => {
          const [exchange, symbol] = connectionKey.split(':')
          if (exchange && symbol && webSocketService) {
            webSocketService.onMessage(exchange, symbol, handlePriceMessage)
            // Handler set up for connection
          }
        })

        // Update previous connections
        previousConnections = new Set(activeConnections)
      }
    }

    // Set up handlers for existing connections
    setupHandlersForActiveConnections()

    // Set up a periodic check for new connections (less frequent)
    if (webSocketService) {
      setInterval(() => {
        if (webSocketService) {
          setupHandlersForActiveConnections()
        }
      }, 30000) // Check every 30 seconds instead of 5
    }

    // WebSocket service initialized and connected to price store
  }

  // Initialize on client side only
  if (import.meta.client) {
    // Use nuxtApp hook instead of onMounted in plugin context
    nuxtApp.hook('app:mounted', () => {
      initializeWebSocketService()
    })
  }

  return {
    provide: {
      webSocketService,
      initializeWebSocketService
    }
  }
})
